module.exports = __webpack_public_path__ + "static/media/BO.56420929.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/BO.svg
// module id = 209
// module chunks = 0